/* eslint-disable react/prop-types */
import {
  Checkbox,
  CheckboxGroup,
  Stack,
  Button,
  Menu,
  MenuButton,
  MenuList,
  FormLabel,
  Grid,
  GridItem,
} from "@chakra-ui/react";

const MultiSelect = ({
  placeholder = "Select Values",
  onChangeHandler,
  value,
  listvalue,
  name,
  onBlurHandler,
}) => {
  // Custom onChange handler to include the name attribute
  const handleChange = (selectedValues) => {
    const event = {
      target: {
        name: name,
        value: selectedValues,
      },
    };
    onChangeHandler(event);
  };

  return (
    <>
      <FormLabel fontSize="1rem" color="#1A202C" htmlFor={name}>
        {"Fuel"}
      </FormLabel>
      <Menu closeOnSelect={false} onClose={onBlurHandler}>
        {/* <MenuButton
          as={Button}
          variant={"filled"}
          w="full"
          textAlign="left"
          borderRadius="lg"
          _focus={{
            borderColor: "blue.500",
            boxShadow: "0 0 0 1px blue.500"
          }}
          _hover={{ bg: "gray.200" }}
          _active={{ bg: "gray.300" }}
          name={name}
           bg="gray.100" // Filling the background of the button (equivalent to 'filled' variant)
          color="black" // Text color for the button
          // border="1px solid #E2E8F0" // Border color (similar to filled button)
        >
          {value?.length > 0 ? `${value?.length} item selected` : placeholder}
        </MenuButton> */}
        {/* <MenuList maxH="300px" overflowY="auto" zIndex={10}> */}
          <CheckboxGroup name={name} value={value} onChange={handleChange}>
            <Stack spacing={2} >
              <Grid  templateColumns={{
            base: "1fr",
            md: "repeat(2, 1fr)",
            // lg: "repeat(4,1fr)",
          }}>
              {listvalue?.map((state,index) => (
                  <GridItem key={index}>
                    <Checkbox key={state} value={state} fontWeight={400}>
                      {state}
                    </Checkbox>
                  </GridItem>
              ))}
              </Grid>
            </Stack>
          </CheckboxGroup>
        {/* </MenuList> */}
      </Menu>
    </>
  );
};

export default MultiSelect;
